import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {environment} from '@env/environment';
import {canShowVatReport, resolveVatReportAccess} from '@shared/helpers/vat-report/access';
import {AuthService} from '@shared/services/auth.service';
import {filter, map, take} from 'rxjs/operators';

/** Bei DENY zurück zur Startseite (A6) – kein Bezug zu Transaktionen. */
const FALLBACK_URL = ['/'];

/**
 * Beta-Gate des Moduls „Umsatzsteuer“ (Spec 10): Dev ALLOW; Beta/Prod nur Pilot-Allowlist
 * `vatReportBetaCustomerIDs`; Pool wartet einmal auf `customerID$`; Root-Prod DENY.
 * Identische Entscheidung wie Nav-Filter und What's-New über `resolveVatReportAccess`.
 *
 * @author Anthony Nahas
 * @since 11.09.26
 */
export const vatAccessGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const decision = resolveVatReportAccess(environment, authService.customerID);
    if (decision === 'ALLOW') {
        return true;
    }
    if (decision === 'DENY') {
        return router.createUrlTree(FALLBACK_URL);
    }

    // Pool: customerID kommt asynchron aus den Custom Claims → einmal warten, dann entscheiden.
    return authService.customerID$.pipe(
        filter(Boolean),
        take(1),
        map(customerID => canShowVatReport(customerID) ? true : router.createUrlTree(FALLBACK_URL))
    );
};
